import { LogementPageBase, ViewKind } from "../LogementPageBase";

export const ViewLogementPage = () => {
    return <LogementPageBase viewKind={ViewKind.Read} />;
};
